<template>
	<div class="poi-view" :class="{'full-page': listPageVisible, 'page-hidden': this.isHiddenPage}">
		<nav-bar :has-more="false" style="position: relative;">
			<div class="search-bar">
				<div class="dot" :class="stopType"></div>
				<input class="search-inp" ref="inp" id="poi-search" :placeholder="placeholder" v-model="inpValue" @click="onInputClick" @input="onInput" @focus="onInputFocus" @blur="onInputBlur"/>
				<transition name="fade">
					<div class="clear" v-show="clearBtnVisible" @click="clear"></div>
				</transition>
			</div>
		</nav-bar>
		<div v-if="listPageVisible" class="box">
      <div v-if="poiType === 'off' && !disabledMap" class="map-poi" @click="onMapPoi">
        <img src="../../assets/img-v2/ic_search_map_poi.png" class="map-select">
        <div>地图选点</div>
      </div>
			<poi-searching v-if="searching"/>
			<div class="tip" v-show="tip">{{tip}}</div>
			<div v-if="list.length" class="list-box" :class="{ 'list-space': showCommonPlace }">
				<div v-if="showCommonPlace" class="list-title">常用站点</div>
				<div class="list">
					<component :is="listItemComp" v-for="(item, index) in list" :key="index" :data-source="item" :poi-type="poiType" :index="index" @click="onResultClick"/>
				</div>
			</div>
			<div class="empty" v-else-if="!searching">
				<img src="../../assets/img-v2/ic_search_empty.png" class="icon" />
				<div class="txt">暂无结果，换个词试试吧</div>
			</div>

		</div>

		<div v-if="!listPageVisible" class="bottom" ref="obstruction">
			<div v-if="!dragNearestOffStop">
				<div class="title">拖动地图选择下车站点</div>
				<div class="desc">蓝色区域为服务区域</div>
			</div>
			<div v-else>
				<div class="title">{{dragNearestOffStop.name}}</div>
				<div class="desc">已为您推荐距离目的地最近的下车站</div>
			</div>
			<VanButton class="set-btn" type="primary" :disabled="!dragNearestOffStop" @click="onClickBottomBtn">设置为下车站</VanButton>
		</div>


    <state-loading v-if="isHiddenPage" />
	</div>
</template>
<script>
import {mapGetters} from 'vuex';
import NavBar from "../../components/nav-bar/index";
import PoiCard from "./components/poi-card";
import PoiAutocompleteCard from "./components/poi-autocomplete-card";
import PoiSearching from "./components/poi-searching";
import StateLoading from '../../components/state-loading/index.vue'
import {POI__LIST_TYPE} from "./store";
import { AREA_MODE } from '../../const/area';

export default {
	name: 'Poi',
	components: {PoiSearching, PoiAutocompleteCard, PoiCard, NavBar, StateLoading},
	data() {
		return {
			tip: '',
			list: [],
			inpValue: '',
			clearBtnVisible: false,
			bottomClicked: false,
			offStopBackup: null,
			selectedOffStopName: '',
			endSearchPoint: {
				lng: null,
				lat: null
			},
      poiType: '', // on:上车 off:下车
      areaId: '', // 区域id
      disabledMap: false, // 禁止进入地图选点
			isHiddenPage: false // 是否隐藏页面
		};
	},
	computed: {
		...mapGetters({
			searching: 'statePoiSearching',
			stopType: 'poi/stopType',
			placeholder: 'poi/placeholder',
			listType: 'poi/listType',
			searchingPoint: 'poi/searchingPoint',
			areaCenterPos: 'dataAreaCenterPos',
			onStop: 'dataOnStop',
			offStop: 'dataOffStop',
			dragNearestOffStop: 'stateDragNearestOffStop',
      isHubArea: "run/isHubArea", // 是否枢纽站模式
		}),
		hubCommonParams() {
			return this.isHubArea ? { 
				mode: AREA_MODE.HUB
			} : {
				mode: AREA_MODE.INNEAR
			}
		},
		listItemComp() {
			switch (this.listType) {
				case POI__LIST_TYPE.autocomplete: // 自动提示
					return PoiAutocompleteCard;
				case POI__LIST_TYPE.search: // 后台搜索
					return PoiCard;
				default:
					return undefined;
			}
		},
		listPageVisible() {
			return !this.$store.state.map.state.mapVisible;
		},
		// 显示常用地点
		showCommonPlace() {
			return this.poiType === 'off' && !(this.inpValue && this.inpValue.trim());
		}
	},
	watch: {
		searchingPoint: {
			immediate: true,
			handler(point) {
				if (point && point.length) {
					this.$PoiService.setListTypeSearch();
					this.tip= '';
					const [lng, lat] = point;
					let outOfRange = this.$MapService.isPointOutOfRange(new BMapGL.Point(lng, lat));
					this.$PoiService.fetchNearStops({
						lng,
						lat,
						...(this.areaId ? {lineId: this.areaId}:{}),
						...(this.hubCommonParams)
					}).then((res = []) => {
						console.log('【poi】获取到附近车站', res);
						this.list = [...res];
						if (this.$PoiService.isStopTypeOff()) {
							if (outOfRange) {
								console.log('outofrange');
								return;
							}
							let [firstRecommendStop] = res;
							let {lng, lat} = firstRecommendStop || {};
							if (lng && lat) {
								let point = new BMapGL.Point(lng, lat);
								this.$MapService.setMapDataOffStop(Object.assign({}, firstRecommendStop, {point}));
								this.$MapService.setDragNearestOffStop(firstRecommendStop);
								this.$MapService.setMapFitViewModeE();
							}
						} else {
							if (outOfRange) {
								this.tip = '您搜索的地址不在本运营区域内，已为您推荐最近的站点';
							} else {
								this.tip = '';
							}
						}
					}).catch(e => {
						console.log('获取附近车站错误', e);
					}).finally(() => {
						this.$MapService.setStatePoiSearching(false);
					});
				}
			}
		}
	},
	activated() {
    const {type, areaId, disabledMap} = this.$route.query || {}
    if (type) {
      this.poiType = type
    }
    if (areaId) {
      this.areaId = areaId
    }
    if (disabledMap) {
      this.disabledMap = disabledMap + '' === '1'
    }
    console.log('areaId', this.areaId, this.poiType)
		this.tip = '';
		this.bottomClicked = false;
		this.selectedOffStopName = '';
		this.$MapService.setDragNearestOffStop(null);
		this.$MapService.setStatePoiSearching(true);
		setTimeout(() => {
			this.offStopBackup = this.offStop;
			this.$MapService.setStateMapVisible(false);
			// 获取默认推荐列表
			this.recommend();
			if (this.$PoiService.isStopTypeOff()) {
				this.$MapService.setStateOnStopDraggable(false);
			}
		});
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			if(!from.name) {
				const guard = vm.$dialog.alert({
					content: `刷新页面导致数据发生变化，请返回首页重新选择`,
					onOk: () => {
						if (window.history.length > 1) {
							vm.$router.back();
						} else {
							vm.$HomeService.turnToHomeView();
						}
          	guard.hide();
					}
				})
				guard.show();
			}
		})
	},
	beforeRouteLeave(to, from, next) {
		// 如果在地图上选择了下车站，但是没有点确定按钮，直接返回，应该把下车站恢复回去
		if (!this.bottomClicked && this.$PoiService.isStopTypeOff()) {
			this.$MapService.setMapDataOffStop(this.offStopBackup);
			if (!this.OffStop) {
				this.$MapService.setStateOnStopDraggable(true);
				this.$MapService.setStateOffStopDraggable(false);
			}
		}
		this.$PoiService.setStopType(null);
		this.clear();
		next();
	},
	methods: {
		async recommend() {
			const recommendList = await this.$PoiService.fetchRecommend(this.areaId, {...this.hubCommonParams});
			this.list = [...recommendList];
		},
		onInputClick(ev) {
			ev.target.focus();
			if (this.inpValue) {
				this.clearBtnVisible = true;
			} else {
				this.clearBtnVisible = false;
			}
		},
		// 不能含有'`'、'\'字符
		checkInputValue(value) {
			return !value.includes('`') && !value.includes('\\');
		},
		onInput() {
			if (!this.inpValue) {
				this.clearBtnVisible = false;
				return
			}
			this.clearBtnVisible = true;
			if (!this.checkInputValue(this.inpValue)) {
				this.$toast('输入内容不能含有特殊字符');
				// 仅去掉特殊字符
				setTimeout(() => {
					this.inpValue = this.inpValue.replace(/`|\\/g, '');
				}, 500)
				return;
			}
			this.$PoiService.setListTypeAutocomplete();
			this.$MapService.setStatePoiSearching(true);
			let hasLocation = true;
			this.$PoiService.fetchPoiList(this.inpValue, this.areaId, this.disabledMap, {
				...this.hubCommonParams,
				upDownFlag: this.$PoiService.isStopTypeOff() ? 1 : 0
			}).then((list = []) => {
				console.log('pia', list);
				list = [...list].map((poi) => {
					let {location = {}} = poi || {};
					let {lng, lat} = location || {};
					let point = new BMapGL.Point(lng, lat);
					hasLocation = lng && lat;
					return Object.assign({}, poi, {point});
				});
				if (hasLocation) {
					this.list = [...list];
				}
			}).finally(() => {
				this.$MapService.setStatePoiSearching(false);
			})
		},
		onInputFocus() {
			this.$MapService.setStateMapVisible(false);
		},
		onInputBlur() {
			this.clearBtnVisible = false;
		},
		onResultClick(item) {
			if (this.$PoiService.isListTypeAutocomplete()) {
				this.onAutocompleteItemClick(item);
				this.$MapService.setStateMapVisible(this.$PoiService.isStopTypeOff());
				this.$nextTick(() => {
					if (this.$refs.obstruction) {
						this.$MapService.observeMapObstruction(this.$refs.obstruction);
					}
				});
			}
			if (this.$PoiService.isListTypeSearch()) {
				this.onSearchItemClick(item);
			}
		},
		onAutocompleteItemClick(item) {
			const {point: {lng: searchLng, lat: searchLat} = {}, name} = item || {};
			if (searchLng && searchLat) {
				this.list = [];
				this.$PoiService.setSearchingPoint(searchLng, searchLat);
			}
			if (name) {
				this.inpValue = name;
			}
			if (this.$PoiService.isStopTypeOff()) {
				this.endSearchPoint = Object.assign({}, {
					lng: searchLng,
					lat: searchLat
				});
				this.$MapService.setStateOnStopDraggable(false);
				this.$MapService.setStateOffStopDraggable(true);
				let lng = searchLng;
				let lat = searchLat;
				let outOfRange = this.$MapService.isPointOutOfRange(new BMapGL.Point(searchLng, searchLat));
				let nearestStop = this.$MapService.findNearestStopByPos({lng: searchLng, lat: searchLat});
				console.log('---- -1: ', nearestStop, outOfRange);
				let {lng: nearLng, lat: nearLat} = nearestStop || {};
				console.log('---- 0: ', lng, lat, nearLng, nearLat);
				if (nearLng && nearLat) {
					let isFar = this.$MapService.isPointFarFromUser(new BMapGL.Point(nearLng, nearLat), 1000);
					console.log('---- 1: ', isFar);
					if (!isFar || !outOfRange) {
						console.log('---- 2');
						lng = nearLng;
						lat = nearLat;
						let point = new BMapGL.Point(lng, lat);
						let stop = Object.assign({}, nearestStop, {
							point
						});
						this.$MapService.setMapDataOffStop(stop);
						this.$MapService.setDragNearestOffStop(nearestStop);
						this.$MapService.setMapFitViewModeE();
						return;
					}
				}
				console.log('---- 3');
				let point = new BMapGL.Point(lng, lat);
				let stop = Object.assign({}, {lng, lat}, {
					point,
					id: 0,
					warn: '请拖动地图到蓝色区域选择站点'
				});
				this.$MapService.setMapDataOffStop(stop);
				this.$MapService.setDragNearestOffStop(null);
				this.$MapService.setMapFitViewModeE();
			} else {
				this.$MapService.setStateOnStopDraggable(true);
				this.$MapService.setStateOffStopDraggable(false);
			}
		},
		onSearchItemClick(item) {
			console.log('onSearchItemClick', item);
			let {lng, lat} = item || {};
			if (lng && lat) {
				let point = new BMapGL.Point(lng, lat);
				let stop = Object.assign({}, item, {point});
				if (this.$PoiService.isStopTypeOn()) {
					if (this.$MapService.isPointFarFromUser(point, 1000)) {
						let guard = this.$dialog.confirm({
							content: '您距离所选站点较远确定在此乘车吗？',
							confirmText: '确认',
							onOk: () => {
								this.$MapService.setMapDataOnStop(stop);
								this.clear();
								this.$router.back();
							}
						});
						guard.show();
						return;
					} else {
						this.$MapService.setMapDataOnStop(stop);
						this.clear();
						this.$router.back();
					}
				}
				if (this.$PoiService.isStopTypeOff()) {
					this.$MapService.setStateOnStopDraggable(false);
					this.bottomClicked = true;
					let nearestStop = this.$MapService.findNearestStopByPos(stop);
					let {id: nearestId} = nearestStop || {};
					let {id: onStopId} = this.onStop || {};
					if (nearestId && onStopId && nearestId === onStopId) {
						this.$cheToast({
							type: 'fail',
							text: '该站点已被选为上车站，请重新选择'
						});
						this.$MapService.setStateOffStopDraggable(true);
						return;
					}
					this.$MapService.setDragNearestOffStop(nearestStop);
					this.$MapService.setMapDataOffStop(stop);
					this.clear();
					this.$router.back();
				}
			}
		},
		onClickBottomBtn() {
			if (!this.dragNearestOffStop) {
				this.$toast('请拖拽选择下车站点');
				return;
			}
			this.$MapService.setStateOffStopDraggable(false);
			let item = this.offStop;
			let {lng, lat} = item || {};
			if (lng && lat) {
				let point = new BMapGL.Point(lng, lat);
				let stop = Object.assign({}, item, {lng, lat, point});
				let nearestStop = this.$MapService.findNearestStopByPos(stop);
				let {id: nearestId} = nearestStop || {};
				let {id: onStopId} = this.onStop || {};
				if (nearestId && onStopId && nearestId === onStopId) {
					this.$cheToast({
						type: 'fail',
						text: '该站点已被选为上车站，请重新选择'
					});
					this.$MapService.setStateOffStopDraggable(true);
					return;
				}
				this.$MapService.setStateOffStopDraggable(false);
				this.$MapService.setMapDataOffStop(Object.assign({}, nearestStop, stop, item));
				this.bottomClicked = true;
			}
			this.clear();
			this.$router.back();
		},
		clear() {
			this.inpValue = '';
			let inp = this.$refs.inp;
			if (inp) {
				inp.blur();
			}
			setTimeout(() => {
				this.list = [];
			}, 200)
		},
    // 地图选点
    onMapPoi() {
      const { id } = this.offStop || {}
      this.$PoiService.setListTypeAutocomplete();
			this.isHiddenPage = true
      if (id) {
        this.onResultClick(this.offStop)
      } else {
        const { lat, lng } = this.areaCenterPos || {}
        this.onResultClick({
          point: {
            lat,
            lng
          },
          name: '区域中心点'
        })
      }
			setTimeout(() => {
				this.isHiddenPage = false
			}, 800)
    }
	}
}
</script>

<style scoped lang="scss">
	@import "../../assets/style/common.scss";
	.poi-view {
		z-index: 100;
		font-size: 12px;
		height: auto;

		&.full-page {
			background: #F3F4F5;
			min-height: 100vh;
			padding-bottom: 10px;
			@extend .common-page;
		}

		.search-bar {
			width: 100%;
			padding: 8px 16px 8px 0;
			position: relative;
		}

		.dot {
			width: 9px;
			height: 9px;
			position: absolute;
			top: 50%;
			left: 18px;
			border-radius: 50%;
			transform: translate3d(0, -50%, 0);
			&.on {
				background: #04B47C;
			}
			&.off {
				background: #006EFA;
			}
		}

		.search-inp {
			width: 100%;
			height: 40px;
			background: #F3F4F5;
			border-radius: 22px;
			border: 1px solid #DEE0E3;
			outline: none;
			padding-left: 40px;
			padding-right: 40px;
			line-height: 22px;
			color: #000000;
			font-size: 16px;
			display: block;
			-webkit-appearance: none;
			appearance: none;
			box-shadow: none;
			display: flex;
			align-items: center;
			&::placeholder {
				width: 240px;
				height: 22px;
				font-size: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #999999;
				line-height: 22px;
			}
		}

		.clear {
			width: 16px;
			height: 16px;
			position: absolute;
			top: 50%;
			right: 36px;
			transform: translateY(-50%);
			background-image: url("../../assets/img-v2/ic_search_clear.png");
			background-position: center;
			background-size: 16px;
			background-repeat: no-repeat;
		}

		.box {
			margin: 10px 10px 30px 10px;
		}

		.list {
			background: #ffffff;
			border-radius: 12px;
			position: relative;
			margin-top: 10px;
		}

		.list-box {
			position: relative;
		}
		.list-space {
			margin-top: 58px;
		}
    .list-title {
			position: absolute;
			top: -48px;
			width: 100%;
			height: 60px;
			display: flex;
			align-items: center;
			padding: 0 14px;
			border-radius: 12px 12px 0px 0px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
			line-height: 20px;
			text-align: left;
			font-style: normal;
			background: #F7F8FA;
    }

		.tip {
			width: 375px;
			background: #EAF5FF;
			font-size: 13px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #1792FF;
			line-height: 20px;
			padding: 10px 18px;
			margin-bottom: -10px;
		}

		.empty {
			position: absolute;
			white-space: nowrap;
			top: 160px;
			left: 50%;
			transform: translate3d(-50%, -50%, 0);
			height: 23px;
			font-size: 17px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #999999;
			line-height: 23px;
		}
		.icon {
			width: 160px;
			height: 160px;
		}

		.txt {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #999999;
			line-height: 20px;
		}

		.bottom {
			position: fixed;
			bottom: 0;
			left: 0;
			right: 0;
			background: #FFFFFF;
			box-shadow: 0px -2px 8px 0px #D7E3EA;
			border-radius: 28px 28px 0px 0px;
			padding: 20px;
			padding-bottom: calc(20px + constant(safe-area-inset-bottom));
			padding-bottom: calc(20px + env(safe-area-inset-bottom));
			.title {
				font-size: 16px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 700;
				color: #333333;
				line-height: 22px;
			}
			.desc{
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #666666;
				line-height: 20px;
				text-align: left;
				font-style: normal;
				margin: 10px 0 20px 0;
			}
			.set-btn {
				width: 100%;
				background: linear-gradient( 90deg, #00A7FD 0%, #006EFA 100%);
				border-radius: 25px;
				border: none;
				font-size: 18px;
				font-weight: 500;
			}
		}
    .map-poi {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 14px;
      background: #ffffff;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #000000;
			line-height: 20px;
			text-align: left;
			font-style: normal;
			box-shadow: inset 0px -1px 0px 0px rgba(238,238,238,0.5);
			border-radius: 12px;
    }

		.map-select {
			width: 20px;
			height: 20px;
			margin-right: 8px;
		}
	}
	.page-hidden {
		position: fixed;
		background: #fff;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		.bottom {
			opacity: 0;
		}
	}
</style>
